
import { Component, Vue } from "vue-property-decorator";
import { SMUser } from "@/store";
import { EMPLOYER_ROLE } from "@/constants/roles";
import WidgetTemplate from "@/components/Widgets/Templates/WidgetTemplate.vue";
import Image from "@/assets/images/people/person-2.png";
import BackgroundImage from "@/assets/images/widgets/background-1.png";

const MESSAGES = {
  candidate: {
    subtitle: "We are generating your report!",
    text:
      "We will inform you once the report is ready. You'll get access " +
      "to your Skilled Worker visa eligibility, fees associated with immigration " +
      "process and approximate timelines.",
  },
  employer: {
    subtitle: "We are generating your report!",
    text:
      "We will inform you once the report is ready. You'll get access " +
      "to your candidate's eligibility, fees associated with immigration " +
      "process and approximate timelines.",
  },
};

@Component({
  components: {
    WidgetTemplate,
  },
})
export default class ReportGeneratedEmployerWidget extends Vue {
  get messages() {
    if (SMUser.user?.role === EMPLOYER_ROLE) {
      return MESSAGES.employer;
    }

    return MESSAGES.candidate;
  }

  image = Image;
  backgroundImage = BackgroundImage;
}
